export const categorySlider = function() {
    const categoryContainer = document.querySelector('.jsCategorySilder'),
          subcategoryContainer = document.querySelector('.jsSubategorySilder'),
		  categoryActiveClass = 'category-navigation__link--active',
		  subcategoryActiveClass = 'subcategory-navigation__link--active';
    categorySlider();
    subcategorySlider();

    function categorySlider() {
		if (!categoryContainer) return;
		const categorySlides = categoryContainer.querySelectorAll('.swiper-slide');
        if (categorySlides.length < 3) return;
        const categorySwiper = new Swiper(categoryContainer, {
            noSwiping: true,
            allowSlidePrev: true,
            allowSlideNext: true,
            slidesPerView: 2.5,
            initialSlide: checkCurrentSlide(categoryContainer, categoryActiveClass),
            centeredSlides: true,
            breakpointsInverse: true,
            breakpoints: {
               768: {
                   slidesPerView: 4.5,
                   noSwiping: true,
                   centeredSlides: true,
                   allowSlidePrev: true,
                   allowSlideNext: true
               },
               1024: {
                   noSwiping: false,
                   allowSlidePrev: false,
                   allowSlideNext: false,
                   centeredSlides: false,
                   slidesPerView: 'auto'
               }
            }
       });

	   const lastSlideIndex = categoryContainer.querySelectorAll('.swiper-slide').length - 1;
       if (categorySwiper.activeIndex === 0 || categorySwiper.activeIndex === lastSlideIndex) {
          categorySwiper.params.centeredSlides = false;
          categorySwiper.update();
       }
    }

    function subcategorySlider() {
        if (!subcategoryContainer) return;
        const subcategorySwiper = new Swiper(subcategoryContainer, {
            initialSlide: checkCurrentSlide(subcategoryContainer, subcategoryActiveClass) - 1,
			slidesPerView: 'auto',
			freeMode: 'true'
       });
    }

    function checkCurrentSlide(sliderContainer, activeCalss) {
        const allSlides = sliderContainer.querySelectorAll('.swiper-slide');
        for (let i = 0; i < allSlides.length; i++) {
            if (allSlides[i].classList.contains(activeCalss)) return i;
        }
    }
}
